export default __webpack_public_path__ + "static/media/newblp_Users.6a5ada1d.svg";